import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import {
  EmailDto,
  EmailEventsFindAllRequestDto,
  EmailEventsFindAllResponseDto,
  EmailsFindAllRequestDto,
  EmailsFindAllResponseDto
} from './vive-api-models';

class EmailsService extends ViveApiBaseService {
  public async findAll(params: {
    options?: ViveApiRequestOptions;
    queryParams?: Omit<EmailsFindAllRequestDto, 'includeAssociations'>;
  }): Promise<EmailsFindAllResponseDto> {
    const { options, queryParams } = params;
    return await this.sendGet<EmailsFindAllResponseDto>({
      apiEndpoint: 'emails',
      options,
      queryParams
    });
  }

  public async findOneById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { emailId: number };
  }): Promise<EmailDto> {
    const { options, pathParams } = params;
    return await this.sendGet<EmailDto>({
      apiEndpoint: 'emails/:emailId',
      options,
      pathParams
    });
  }

  public async findAllEvents(params: {
    options?: ViveApiRequestOptions;
    pathParams: { emailId: number };
    queryParams?: Omit<EmailEventsFindAllRequestDto, 'includeAssociations'>;
  }): Promise<EmailEventsFindAllResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<EmailEventsFindAllResponseDto>({
      apiEndpoint: 'emails/:emailId/events',
      options,
      pathParams,
      queryParams
    });
  }
}

export const emailsService = new EmailsService();
